import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

const pinia = createPinia();
import router from './router'
import './services/http'
import 'bootstrap/dist/css/bootstrap.css'

import 'icheck-bootstrap/icheck-bootstrap.css'
import './services/tracking'

import './assets/theme/demos/demo-6.css'
import './assets/theme/style.css'
import './assets/theme/custom.css'
import './assets/css/app.css'
import 'bootstrap'



const app = createApp(App);
 app.use(pinia).use(router).mount('#app')

